import { render, staticRenderFns } from "./BillsDetail.vue?vue&type=template&id=a16ee326"
import script from "./BillsDetail.vue?vue&type=script&lang=js"
export * from "./BillsDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports